export enum AdresTuru {
    YURT_ICI_IKAMETGAH = "ADRTR00001",
    YURT_ICI_ISYERI = "ADRTR00002",
    DEPO = "ADRTR00003",
    ASKERLIK = "ADRTR00004",
    YURTDISI_IKAMETGAH = "ADRTR00005",
    YURTDISI_ISYERI = "ADRTR00006",
    CEZAEVI = "ADRTR00007",
    MERNIS = "ADRTR00008",
    AVUKATLIK = "ADRTR00009",
    ESKI_MERNIS = "ADRTR00010",
    MERSIS = "ADRTR00011",
    ESKI_MERSIS = "ADRTR00012",
    ELEKTRONIK_TEBLIGAT = "ADRTR00013",
    ESKI_ELEKTRONIK_TEBLIGAT = "ADRTR00014",
    AVUKATLIK_ELEKTRONIK_TEBLIGAT = "ADRTR00015",
    SONIM = "ADRTR00016",
    BILIRKISI_BEYAN = "ADRTR00018",
}